import { render, staticRenderFns } from "./TownDashboard.vue?vue&type=template&id=79ebd479"
import script from "./TownDashboard.vue?vue&type=script&lang=js"
export * from "./TownDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports